/* New order sheet (block layout). Admin-only until the admin switch in Partners → settings is on. */
import { useEffect, useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { FileSpreadsheet, Loader2 } from "lucide-react";
import { API, getAuthHeader } from "@/App";
import { Button } from "@/components/ui/button";
import { Switch } from "@/components/ui/switch";

export const OrderSheetButton = () => {
  const [st, setSt] = useState(null);
  const [busy, setBusy] = useState(false);
  useEffect(() => { axios.get(`${API}/order-register/order-sheet/status`, { headers: getAuthHeader() }).then((r) => setSt(r.data)).catch(() => {}); }, []);
  if (!st?.can_use) return null;
  const dl = async () => {
    setBusy(true);
    try {
      const r = await axios.get(`${API}/order-register/order-sheet/template`, { headers: getAuthHeader(), responseType: "blob" });
      const a = document.createElement("a"); a.href = URL.createObjectURL(r.data); a.download = "order_sheet.xlsx"; a.click();
    } catch { toast.error("Could not download the order sheet"); }
    setBusy(false);
  };
  return (
    <Button size="sm" variant="outline" onClick={dl} disabled={busy} data-testid="or-order-sheet-btn"
      title={st.live ? "New order sheet — upload it with Upload Excel" : "New order sheet (admin only for now — turn it on for the team in Partners → settings). Upload it with Upload Excel"}>
      {busy ? <Loader2 className="w-4 h-4 mr-1 animate-spin" /> : <FileSpreadsheet className="w-4 h-4 mr-1" />}
      Order sheet{!st.live && <span className="ml-1 rounded bg-amber-100 px-1 text-[9px] font-bold text-amber-700">ADMIN</span>}
    </Button>
  );
};

// Partners → settings: one switch shows the new sheet to partners (Hub) and the team (ERP).
export const OrderSheetSwitch = () => {
  const [live, setLive] = useState(null);
  useEffect(() => { axios.get(`${API}/portal-admin/settings`, { headers: getAuthHeader() }).then((r) => setLive(!!r.data.order_sheet_live)).catch(() => {}); }, []);
  const flip = async (v) => {
    try {
      const r = await axios.put(`${API}/portal-admin/order-sheet`, { live: v }, { headers: getAuthHeader() });
      setLive(r.data.order_sheet_live);
      toast.success(v ? "New order sheet is now live for partners and the team" : "New order sheet hidden — admins only");
    } catch { toast.error("Could not save"); }
  };
  if (live === null) return null;
  return (
    <div className="flex flex-wrap items-center gap-2 rounded-xl border bg-slate-50 px-3 py-2 text-xs" data-testid="pa-order-sheet">
      <b>New order sheet</b>
      <Switch checked={live} onCheckedChange={flip} data-testid="pa-order-sheet-switch" />
      <span className={live ? "font-semibold text-emerald-700" : "text-slate-500"}>{live ? "Live — partners get the new sheet + upload window; team can upload it" : "Admin only — partners keep the current template"}</span>
    </div>
  );
};
